import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Importa los estilos de AOS
import styles from './S2.module.css'; // Asegúrate de que la ruta sea correcta
import logo1 from './images/imagen1.png';
import logo2 from './images/imagen2.png';
import logo3 from './images/imagen3.png';
import logo4 from './images/imagen4.png';
import backgroundVideo from './images/background.mp4'; // Asegúrate de tener tu video en esta ruta

const S2 = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 }); // Inicializa AOS con una duración de 2000ms
  }, []);

  return (
    <div className={styles.contenedor} data-aos="fade-up">
      {/*<video autoPlay loop muted playsInline className={styles.videoBackground}>
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>*/}
      <div className={styles.texto} data-aos="fade-in">
        <span className={styles.highlightBlanco}>Proveedores de</span> <span className={styles.highlightAzul}>IA Generativa </span><span className={styles.highlightBlanco}>con los que nos asociamos</span>
      </div>
      <div className={styles.logosCarouselContainer}>
        <div className={styles.logosCarousel}>
          <img src={logo1} alt="Anthropic" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo2} alt="Google" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo3} alt="Meta" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo4} alt="OpenAI" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo1} alt="Anthropic" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo2} alt="Google" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo3} alt="Meta" className={`${styles.logo} ${styles.logoFloat}`} />
          <img src={logo4} alt="OpenAI" className={`${styles.logo} ${styles.logoFloat}`} />
        </div>
      </div>
    </div>
  );
};

export default S2;
